// Base selectors
export const BASE_SELECTOR = '#SITE_CONTAINER.focus-ring-active'
export const KEYBOARD_TABBING = '.keyboard-tabbing-on'

// Focus state selectors
export const FOCUS_STATE = ':not(.has-custom-focus):not(.ignore-focus):not([tabindex="-1"]):focus'
export const SIBLING_FOCUS = ' ~ .wixSdkShowFocusOnSibling'

// Component selectors
export const INNER_FOCUS = '.has-inner-focus-ring'
export const KEYBOARD_ONLY = '.has-keyboard-only-focus-ring'

// Focus ring styles
export const FOCUS_RING_COLOR = '#116dff'
export const FOCUS_RING_WIDTH = '2px'
export const FOCUS_RING_OFFSET = '1px'
export const INNER_FOCUS_RING_OFFSET = '-2px'
export const FOCUS_RING_Z_INDEX = '1'

export const BOX_SHADOW_VAR_NAME = '--focus-ring-box-shadow'
export const BOX_SHADOW_WHITE_LINE = '0 0 0 1px #ffffff'
export const BOX_SHADOW_BLUE_LINE = `0 0 0 3px ${FOCUS_RING_COLOR}`

// Focus ring style objects
export const outlineFocusRingStyles = {
	outline: `${FOCUS_RING_WIDTH} solid ${FOCUS_RING_COLOR}`,
	'outline-offset': FOCUS_RING_OFFSET,
	'z-index': FOCUS_RING_Z_INDEX,
}

export const innerOutlineFocusRingStyles = {
	outline: `${FOCUS_RING_WIDTH} solid ${FOCUS_RING_COLOR}`,
	'outline-offset': INNER_FOCUS_RING_OFFSET,
	'z-index': FOCUS_RING_Z_INDEX,
}

export const boxShadowFocusRingStyles = {
	[BOX_SHADOW_VAR_NAME]: `${BOX_SHADOW_WHITE_LINE}, ${BOX_SHADOW_BLUE_LINE}`,
	'box-shadow': `var(${BOX_SHADOW_VAR_NAME}) !important`,
	'z-index': FOCUS_RING_Z_INDEX,
}

export const innerBoxShadowFocusRingStyles = {
	[BOX_SHADOW_VAR_NAME]: `inset ${BOX_SHADOW_WHITE_LINE}, inset ${BOX_SHADOW_BLUE_LINE} !important`,
}
